import { render, staticRenderFns } from "./StatServers.vue?vue&type=template&id=7bf99fda&lang=pug&"
import script from "./StatServers.vue?vue&type=script&lang=js&"
export * from "./StatServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports